import { Shell, StepFooter } from "@/components/Shell";
import { ScaleInput } from "@/components/ScaleInput";
import { SYMPTOMS } from "@/lib/questions";

export function SymptomsStep({ answers, setAnswer, onBack, onNext, progress }) {
  return (
    <Shell progress={progress}>
      <span className="cc-eyebrow">Síntomas</span>
      <h1 className="font-serif text-3xl sm:text-4xl mt-3">
        En las últimas 4 semanas
      </h1>
      <p className="mt-3 text-[hsl(var(--muted-foreground))]">
        Indica cuánto has experimentado cada uno. Puedes elegir “Prefiero no
        responder” en cualquier pregunta.
      </p>

      <div className="mt-6 flex flex-wrap gap-2 text-xs">
        <span className="cc-chip">0 · Nada</span>
        <span className="cc-chip">1 · Poco</span>
        <span className="cc-chip">2 · Bastante</span>
        <span className="cc-chip">3 · Mucho</span>
      </div>

      <div className="mt-6 space-y-4">
        {SYMPTOMS.map((s) => (
          <ScaleInput
            key={s.id}
            questionId={s.id}
            label={s.text}
            value={answers[s.id]}
            onChange={(v) => setAnswer(s.id, v)}
          />
        ))}
      </div>

      <StepFooter>
        <button onClick={onBack} className="cc-btn-outline" data-testid="symptoms-back-btn">
          Atrás
        </button>
        <button onClick={onNext} className="cc-btn-primary" data-testid="symptoms-next-btn">
          Continuar
        </button>
      </StepFooter>
    </Shell>
  );
}
